import { useCookies } from 'react-cookie';
import { CookieOptions, CookieManager, ReactCookieOptions } from '../types';

export const CreateReactCookieManager = (): CookieManager => {
    const [cookies, setCookie, removeCookie] = useCookies();

    const normalizeOptions = (options: CookieOptions): ReactCookieOptions => {
        const normalized = { ...options } as ReactCookieOptions;

        if (normalized.expires) {
            if (typeof normalized.expires === 'number') {
                normalized.expires = new Date(normalized.expires);
            } else if (typeof normalized.expires === 'string') {
                normalized.expires = new Date(normalized.expires);
            }
        }

        return normalized;
    };

    return {
        set: (name: string, value: string, options: CookieOptions = {}) => {
            const normalizedOptions = normalizeOptions(options);
            setCookie(name, value, normalizedOptions);
        },
        get: (name: string): string | undefined => {
            return cookies[name];
        },
        remove: (name: string, options: CookieOptions = {}) => {
            const normalizedOptions = normalizeOptions(options);
            removeCookie(name, normalizedOptions);
        },
        getAll: (): Record<string, string> => {
            return Object.entries(cookies).reduce(
                (acc, [key, value]) => ({
                    ...acc,
                    [key]: typeof value === 'string' ? value : '',
                }),
                {}
            );
        },
        has: (name: string): boolean => {
            return name in cookies;
        },
    };
};